import { $el } from '../elements';
import { UIValue } from '../types';
import { UIInkBar } from './inkbar';
import { UIExclusiveToggles, UIToggle, UITogglesOptions } from './toggle';

export type UISegmentedKind = 'k-default' | 'k-under' | 'k-tabs' | 'k-new'

export interface UISegmentedOptions extends UITogglesOptions {
    separator?: string;
    kind?: UISegmentedKind;
}

//new version, with  inkbar
export class UISegmented<Key> extends UIExclusiveToggles<UIValue<Key>, Key> {
    constructor(values: UIValue<Key>[], options: UISegmentedOptions = {}) {
        const inkbar = new UIInkBar({ border: 1 });
        options.classes = ['ui-segmented', options.classes, options.kind ?? 'k-default'];
        options.inkbar = inkbar;
        super(values, v => new UIToggle($el.SPAN('r-segment', v.name), { key: v.key }), options)
        this.ui_prepend(inkbar);
    }
}
